export default "__VITE_ASSET__pQIGUvhJ__"